import { createTheme } from '@mui/material';
import { Theme } from '@enums';
import { colors } from '../colors';
import { InterBold, InterMedium, InterRegular } from '../fonts';

var _createTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 824,
      lg: 1024,
      xl: 1366,
      mobile: 0,
      tablet: 728,
      desktop: 1024
    }
  }
}),
    breakpoints = _createTheme.breakpoints,
    spacing = _createTheme.spacing,
    palette = _createTheme.palette,
    pxToRem = _createTheme.typography.pxToRem;

var defaultTheme = createTheme({
  breakpoints: {
    values: breakpoints.values
  },
  palette: {
    mode: Theme.Light,
    background: {
      "default": colors.white
    },
    funGreen: palette.augmentColor({
      color: {
        main: colors.funGreen
      }
    }),
    lightFunGreen: palette.augmentColor({
      color: {
        main: colors.lightFunGreen
      }
    }),
    seaGreen: palette.augmentColor({
      color: {
        main: colors.seaGreen
      }
    }),
    bitterSweet: palette.augmentColor({
      color: {
        main: colors.bitterSweet
      }
    }),
    gin: palette.augmentColor({
      color: {
        main: colors.gin
      }
    }),
    warning: palette.augmentColor({
      color: {
        main: colors.warning
      }
    }),
    santasGray: palette.augmentColor({
      color: {
        main: colors.santasGray
      }
    }),
    whisper: palette.augmentColor({
      color: {
        main: colors.whisper
      }
    }),
    athensGray: palette.augmentColor({
      color: {
        main: colors.athensGray
      }
    }),
    mineShaft: palette.augmentColor({
      color: {
        main: colors.mineShaft
      }
    }),
    sunshade: palette.augmentColor({
      color: {
        main: colors.sunshade
      }
    }),
    comet: palette.augmentColor({
      color: {
        main: colors.comet
      }
    }),
    titanWhite: palette.augmentColor({
      color: {
        main: colors.titanWhite
      }
    }),
    raven: palette.augmentColor({
      color: {
        main: colors.raven
      }
    }),
    frenchGray: palette.augmentColor({
      color: {
        main: colors.frenchGray
      }
    }),
    jewel: palette.augmentColor({
      color: {
        main: colors.jewel
      }
    }),
    maroonFlush: palette.augmentColor({
      color: {
        main: colors.maroonFlush
      }
    })
  },
  typography: {
    htmlFontSize: 16,
    fontFamily: 'Inter, sans-serif',
    h1: {
      fontSize: pxToRem(48),
      lineHeight: pxToRem(56),
      letterSpacing: '-0.02em'
    },
    h2: {
      fontSize: pxToRem(34),
      lineHeight: pxToRem(42),
      letterSpacing: '-0.02em'
    },
    h3: {
      fontSize: pxToRem(24),
      lineHeight: pxToRem(32),
      letterSpacing: '-0.02em'
    },
    h4: {
      fontSize: pxToRem(20),
      lineHeight: pxToRem(32),
      letterSpacing: '-0.02em'
    },
    h5: {
      fontSize: pxToRem(18),
      lineHeight: pxToRem(24)
    },
    body1: {
      fontSize: pxToRem(16),
      lineHeight: pxToRem(20),
      letterSpacing: '-0.003em'
    },
    body2: {
      fontSize: pxToRem(14),
      lineHeight: pxToRem(18),
      letterSpacing: '-0.0015em'
    },
    body3: {
      fontSize: pxToRem(13),
      lineHeight: pxToRem(18)
    },
    caption1: {
      fontSize: pxToRem(12),
      lineHeight: pxToRem(16)
    },
    caption2: {
      fontSize: pxToRem(10),
      lineHeight: pxToRem(14)
    },
    overline: {
      fontSize: pxToRem(12),
      lineHeight: pxToRem(18),
      letterSpacing: '-0.03em'
    }
  },
  mixins: {},
  components: {
    MuiCssBaseline: {
      styleOverrides: "\n        * {\n          font-family: Inter, Helvetica, Arial, sans-serif\n        }\n        *[hidden] {\n          display: none !important;\n          pointer-events: none;\n        }\n        @font-face {\n          font-family: 'Inter';\n          font-style: normal;\n          font-display: swap;\n          font-weight: 400;\n          src: local('Inter'), local('Inter-Regular'), url(".concat(InterRegular, ") format('woff2');\n        }\n        @font-face {\n          font-family: 'Inter';\n          font-style: normal;\n          font-display: swap;\n          font-weight: 500;\n          src: local('Inter'), local('Inter-Medium'), url(").concat(InterMedium, ") format('woff2');\n        }\n        @font-face {\n          font-family: 'Inter';\n          font-style: normal;\n          font-display: swap;\n          font-weight: 700;\n          src: local('Inter'), local('Inter-Bold'), url(").concat(InterBold, ") format('woff2');\n        }\n      ")
    },
    MuiTypography: {
      variants: [{
        props: {
          color: 'mineShaft'
        },
        style: {
          color: colors.mineShaft
        }
      }, {
        props: {
          color: 'comet'
        },
        style: {
          color: colors.comet
        }
      }, {
        props: {
          color: 'raven'
        },
        style: {
          color: colors.raven
        }
      }, {
        props: {
          color: 'frenchGray'
        },
        style: {
          color: colors.frenchGray
        }
      }, {
        props: {
          color: 'bitterSweet'
        },
        style: {
          color: colors.bitterSweet
        }
      }, {
        props: {
          color: 'funGreen'
        },
        style: {
          color: colors.funGreen
        }
      }, {
        props: {
          color: 'lightFunGreen'
        },
        style: {
          color: colors.lightFunGreen
        }
      }, {
        props: {
          color: 'santasGray'
        },
        style: {
          color: colors.santasGray
        }
      }, {
        props: {
          color: 'frenchGray'
        },
        style: {
          color: colors.frenchGray
        }
      }, {
        props: {
          color: 'seaGreen'
        },
        style: {
          color: colors.seaGreen
        }
      }]
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      variants: [{
        props: {
          variant: 'contained'
        },
        style: {
          borderRadius: pxToRem(14),
          color: colors.white,
          fontWeight: 700,
          fontSize: pxToRem(14),
          lineHeight: pxToRem(18),
          letterSpacing: '-0.003em',
          backgroundColor: colors.funGreen,
          border: "1px solid ".concat(colors.funGreen),
          ':hover': {
            backgroundColor: colors.funGreen
          },
          ':disabled': {
            backgroundColor: colors.whisper,
            border: 'none',
            color: colors.raven
          }
        }
      }, {
        props: {
          variant: 'contained',
          color: 'secondary'
        },
        style: {
          borderRadius: pxToRem(14),
          color: colors.white,
          backgroundColor: colors.bitterSweet,
          border: "1px solid ".concat(colors.bitterSweet),
          fontWeight: 500,
          fontSize: pxToRem(14),
          lineHeight: pxToRem(18),
          letterSpacing: '-0.003em',
          ':hover': {
            backgroundColor: colors.bitterSweet
          },
          ':disabled': {
            backgroundColor: colors.whisper,
            border: 'none',
            color: colors.raven
          }
        }
      }, {
        props: {
          variant: 'text'
        },
        style: {
          borderRadius: pxToRem(14),
          color: colors.funGreen,
          fontWeight: 700,
          fontSize: pxToRem(14),
          lineHeight: pxToRem(18),
          letterSpacing: '-0.003em',
          backgroundColor: 'transparent',
          textTransform: 'none'
        }
      }, {
        props: {
          variant: 'outlined'
        },
        style: {
          borderRadius: pxToRem(14),
          color: colors.funGreen,
          fontWeight: 700,
          fontSize: pxToRem(14),
          lineHeight: pxToRem(18),
          letterSpacing: '-0.003em',
          border: "1px solid ".concat(colors.funGreen),
          ':hover': {
            border: "1px solid ".concat(colors.funGreen)
          },
          ':disabled': {
            backgroundColor: colors.whisper,
            border: 'none',
            color: colors.raven
          }
        }
      }, {
        props: {
          variant: 'outlined',
          color: 'comet'
        },
        style: {
          borderRadius: pxToRem(14),
          color: colors.comet,
          fontWeight: 700,
          fontSize: pxToRem(14),
          lineHeight: pxToRem(18),
          letterSpacing: '-0.003em',
          border: "1px solid ".concat(colors.comet),
          ':hover': {
            border: "1px solid ".concat(colors.comet)
          },
          ':disabled': {
            backgroundColor: 'unset',
            border: "1px solid ".concat(colors.frenchGray),
            color: colors.frenchGray
          }
        }
      }, {
        props: {
          variant: 'outlined',
          color: 'bitterSweet'
        },
        style: {
          borderRadius: pxToRem(14),
          color: colors.bitterSweet,
          fontWeight: 700,
          fontSize: pxToRem(14),
          lineHeight: pxToRem(18),
          letterSpacing: '-0.003em',
          border: "1px solid ".concat(colors.bitterSweet),
          ':hover': {
            border: "1px solid ".concat(colors.bitterSweet)
          },
          ':disabled': {
            backgroundColor: colors.whisper,
            border: 'none',
            color: colors.raven
          }
        }
      }, {
        props: {
          variant: 'outlined',
          color: 'secondary'
        },
        style: {
          borderRadius: pxToRem(14),
          color: colors.comet,
          fontWeight: 700,
          fontSize: pxToRem(14),
          lineHeight: pxToRem(18),
          letterSpacing: '-0.003em',
          border: "1px solid ".concat(colors.comet),
          ':hover': {
            border: "1px solid ".concat(colors.comet)
          },
          ':disabled': {
            backgroundColor: colors.whisper,
            border: 'none',
            color: colors.raven
          }
        }
      }, {
        props: {
          color: 'primary',
          variant: 'contained'
        },
        style: {
          backgroundColor: colors.funGreen,
          textTransform: 'none',
          // ':hover':        {
          //   backgroundColor: colors.cornflowerBlue,
          //   boxShadow:       `0px ${pxToRem(8)} ${pxToRem(
          //     25,
          //   )} rgba(0, 41, 255, 0.4)`,
          // },
          ':focus': {
            backgroundColor: colors.funGreen
          },
          ':disabled': {
            backgroundColor: colors.whisper,
            border: 'none',
            color: colors.raven
          }
        }
      }, {
        props: {
          size: 'large'
        },
        style: {
          padding: spacing(1.75, 2.5),
          borderRadius: pxToRem(12)
        }
      }, {
        props: {
          size: 'medium'
        },
        style: {
          padding: spacing(1.5, 2),
          borderRadius: pxToRem(10)
        }
      }, {
        props: {
          size: 'small'
        },
        style: {
          padding: spacing(1, 2),
          borderRadius: pxToRem(8)
        }
      }]
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: colors.waterloo,
          cursor: 'pointer',
          fontSize: pxToRem(14),
          lineHeight: pxToRem(18),
          textDecoration: 'none',
          textUnderlineOffset: pxToRem(3)
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          'path.stroke': {
            stroke: colors.frenchGray
          },
          'rect.stroke': {
            stroke: colors.frenchGray
          },
          'line.stroke': {
            stroke: colors.frenchGray
          },
          'path.fill': {
            fill: colors.frenchGray
          },
          'rect.fill': {
            fill: colors.frenchGray
          },
          'line.fill': {
            fill: colors.frenchGray
          },
          ':disabled': {
            svg: {
              'path.stroke': {
                stroke: colors.catskillWhite
              },
              'rect.stroke': {
                stroke: colors.catskillWhite
              },
              'line.stroke': {
                stroke: colors.catskillWhite
              },
              'path.fill': {
                fill: colors.catskillWhite
              },
              'rect.fill': {
                fill: colors.catskillWhite
              },
              'line.fill': {
                fill: colors.catskillWhite
              }
            }
          }
        }
      },
      variants: [{
        props: {
          color: 'titanWhite'
        },
        style: {
          backgroundColor: colors.titanWhite,
          borderRadius: pxToRem(10),
          ':hover': {
            backgroundColor: colors.titanWhite
          }
        }
      }, {
        props: {
          color: 'whiteLilac'
        },
        style: {
          backgroundColor: colors.whiteLilac,
          borderRadius: pxToRem(10),
          ':hover': {
            backgroundColor: colors.whiteLilac
          }
        }
      }]
    },
    MuiChip: {
      styleOverrides: {
        root: {
          minWidth: pxToRem(116),
          display: 'flex',
          alignItems: 'center',
          height: pxToRem(24),
          borderRadius: pxToRem(8),
          '& .chip-indicator': {
            width: pxToRem(6),
            height: pxToRem(6)
          }
        }
      },
      variants: [{
        props: {
          color: 'seaGreen'
        },
        style: {
          maxWidth: pxToRem(80),
          minWidth: 'unset',
          display: 'inline-flex',
          '& .chip-indicator': {
            padding: "".concat(pxToRem(10), " ").concat(pxToRem(6)),
            backgroundColor: colors.seaGreen,
            borderRadius: pxToRem(8)
          }
        }
      }, {
        props: {
          color: 'bitterSweet'
        },
        style: {
          color: colors.white,
          maxWidth: pxToRem(95),
          minWidth: 'unset',
          display: 'inline-flex',
          '& .chip-indicator': {
            padding: "".concat(pxToRem(10), " ").concat(pxToRem(6)),
            backgroundColor: colors.bitterSweet,
            borderRadius: pxToRem(8)
          }
        }
      }, {
        props: {
          color: 'athensGray'
        },
        style: {
          maxWidth: pxToRem(80),
          minWidth: 'unset',
          display: 'inline-flex',
          '& .chip-indicator': {
            backgroundColor: colors.athensGray,
            borderRadius: pxToRem(8)
          }
        }
      }, {
        props: {
          color: 'sunshade'
        },
        style: {
          color: colors.white,
          display: 'inline-flex',
          minWidth: 'unset',
          '& .chip-indicator': {
            padding: "".concat(pxToRem(10), " ").concat(pxToRem(6)),
            backgroundColor: colors.sunshade,
            borderRadius: pxToRem(8)
          }
        }
      }]
    }
  }
}, {
  colors: colors
});
export { defaultTheme, pxToRem };